<template>
  <div class="ProjectInfo">
    <ComBox title="项目信息" :element="element">
      <div class="info" :style="`font-size: ${changeDevicePixelRatio(element.style.fontSize)}px;margin-top: ${changeDevicePixelRatio(10)}px;`">
        <div
          class="wrapping"
        >
          <div class="text">
            <div class="label ellipsis">项目状态</div>
            <div class="txt">{{ projectItem.projectStatusName }}</div>
          </div>
          <div class="text">
            <div class="label ellipsis">项目类型</div>
            <div class="txt">{{ projectItem.projectTypeName }}</div>
          </div>
        </div>
        <div
          class="wrapping"
        >
          <div class="text">
            <div class="label ellipsis">负责人</div>
            <div class="txt">{{ projectItem.managerName }}</div>
          </div>
          <div class="text">
            <div class="label ellipsis">联系电话</div>
            <div class="txt">{{ projectItem.managerPhone }}</div>
          </div>
        </div>
        <div
          class="wrapping"
        >
          <div class="text">
            <div class="label ellipsis">开工日期</div>
            <div class="txt">
              {{ projectItem.startDate && projectItem.startDate.split(" ")[0] }}
            </div>
          </div>
          <div class="text">
            <div class="label ellipsis">竣工日期</div>
            <div class="txt">
              {{ projectItem.endDate && projectItem.endDate.split(" ")[0] }}
            </div>
          </div>
        </div>
        <div
          class="wrapping"
        >
          <div class="desc" :style="`max-width: ${changeDevicePixelRatio(400)}px;`">地址：{{ projectItem.address }}</div>
        </div>
      </div>
    </ComBox>
  </div>
</template>

<script>
import ComBox from '../ComBox.vue'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import { mapState } from 'vuex'
export default {
  components: { ComBox },
  props: {
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      projectItem: state => state.user.projectItem,
      timeLog: state => state.socket.timeLog
    })
  },

  created() {},

  methods: {
    changeDevicePixelRatio
  }

}
</script>

<style lang="scss" scoped>
.ProjectInfo {
  width: 380px;
  height: 180px;
  overflow: hidden;
  .info{
    margin-top: 10px;
    .wrapping{
        display: flex;
        justify-content: space-between;
        font-family: SourceHanSansCN;
        margin-right: 4%;
        padding-left: 3%;
        line-height: 1.8;
        .text{
            width: 49%;
            display: flex;
            .label{
                width: 38%;
            }
            .txt{
              overflow: hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
              width: 58%;
              margin-left: 4%;
            }
        }
        .desc{
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          word-break: break-all;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
        }
    }
  }
}
</style>
